import { CatalogueAPI, DtoAuthorizeResponse } from "@configura/web-api";
import { toError } from "@configura/web-utilities";
import { useEffect, useState } from "react";

/**
 * To use Public AccessToken, i.e. not requiring Example-Server:
 * Insert your Public AccessToken ID in the row below, like this:
 * const PUBLIC_ACCESS_TOKEN: string | false = "ATEUCE1JQNUWOMZBSZAZZJEEE5GPNXDM";
 */
const PUBLIC_ACCESS_TOKEN: string | false = "ATEUCE12LKOZWQWJUIEEWSK4VHYIMQGS";

/** Only used when using Public AccessToken. Should normally not be changed. */
const CATALOGUE_API_ENDPOINT = "https://catalogueapi.configura.com";

/**
 * Makes a call to Example Server to issue SessionToken for a
 * Private AccessToken stored in the Example Server.
 */
const authWithPrivateAccessToken: () => Promise<DtoAuthorizeResponse> = async () =>
	fetch("/auth").then((res: Response) => res.json());

/**
 * Makes a call to Catalogue API to issue Session token for a
 * Public AccessToken defined in PUBLIC_ACCESS_TOKEN.
 */
const authWithPublicAccessToken: () => Promise<DtoAuthorizeResponse | undefined> = async () => {
	if (!PUBLIC_ACCESS_TOKEN) {
		console.error("ERROR! No Public AccessToken defined");
		return;
	}

	const api = new CatalogueAPI();
	return api.postPublicAccessTokenAuthorize(
		{
			accessTokenId: PUBLIC_ACCESS_TOKEN,
		},
		CATALOGUE_API_ENDPOINT
	);
};

export function useAuth(setError: (error: Error) => void): DtoAuthorizeResponse | undefined {
	const [auth, setAuth] = useState<DtoAuthorizeResponse | undefined>(undefined);

	useEffect(() => {
		let canceled = false;

		let response: Promise<DtoAuthorizeResponse | undefined>;

		if (PUBLIC_ACCESS_TOKEN === false) {
			response = authWithPrivateAccessToken();
		} else {
			response = authWithPublicAccessToken();
		}

		response
			.then((res: DtoAuthorizeResponse | undefined | { error: "string" }) => {
				if (canceled) {
					return;
				}

				if (res === undefined) {
					return;
				}

				if ("error" in res) {
					throw Error(res.error);
				} else {
					setAuth(res);
				}
			})
			.catch((e) => {
				if (canceled) {
					return;
				}
				setError(toError(e));
			});

		return () => {
			canceled = true;
		};
	}, [setError]);

	return auth;
}
